export default __webpack_public_path__ + "static/careers-benefits-block1-icon08.url-81f8a11c693c15942a1087e85a06cb52.svg";